( function () {
	const $maps = document.querySelectorAll( ".google-map" );

	for ( const $map of $maps ) {
		const options = JSON.parse( $map.getAttribute( "data-gmap-options" ) );

		const lat = options.center.lat;
		const lng = options.center.lng;
		const zoom = options.zoom || 14;

		const googleMap = new google.maps.Map($map, {
			zoom: zoom,
			center: new google.maps.LatLng(lat, lng),
			mapTypeId: google.maps.MapTypeId.ROADMAP
		});

		googleMap.markers = [];

		const marker = new google.maps.Marker({
			position: new google.maps.LatLng(lat, lng),
			map: googleMap
		});

		googleMap.markers.push(marker);
	}
} )();
